import React, { useEffect } from 'react';
import toast, { Toaster, useToasterStore } from 'react-hot-toast';

const TOAST_LIMIT = 3;

/** Behält höchstens TOAST_LIMIT sichtbare Toasts (älteste werden geschlossen). */
function ToastLimitEnforcer({ limit = TOAST_LIMIT }) {
  const { toasts } = useToasterStore();

  useEffect(() => {
    const visible = toasts.filter((t) => t.visible);
    if (visible.length <= limit) return;
    // Store: älteste zuerst → neueste behalten
    visible.slice(0, visible.length - limit).forEach((t) => toast.dismiss(t.id));
  }, [toasts, limit]);

  return null;
}

const AppToaster = () => (
  <>
    <ToastLimitEnforcer limit={TOAST_LIMIT} />
    <Toaster
      position="top-left"
      reverseOrder={false}
      gutter={10}
      containerStyle={{
        top: 16,
        left: 16,
        zIndex: 99999,
      }}
      toastOptions={{
        duration: 4000,
        style: {
          background: '#1c1917',
          color: '#fafaf9',
          borderRadius: '14px',
          border: '1px solid rgba(255,255,255,0.06)',
          boxShadow: '0 12px 40px rgba(0,0,0,0.28)',
          fontSize: '13px',
          padding: '12px 14px',
        },
        success: {
          iconTheme: {
            primary: '#a8a29e',
            secondary: '#1c1917',
          },
        },
        error: {
          iconTheme: {
            primary: '#f87171',
            secondary: '#1c1917',
          },
        },
      }}
    />
  </>
);

export default AppToaster;
